import type { CustomerDto } from '../types/customer'

/** Φιλτράρισμα πελατών για αναζήτηση (όνομα, τηλέφωνο, email, ΑΦΜ, διεύθυνση, tags). */
export function filterCustomersBySearch(
  customers: CustomerDto[] | undefined,
  query: string,
): CustomerDto[] {
  if (!customers) return []
  const s = query.trim().toLowerCase()
  if (!s) return customers
  return customers.filter((c) => {
    const hay = [
      c.name,
      c.phone ?? '',
      c.email ?? '',
      c.vatNumber ?? '',
      c.address ?? '',
      (c.tags ?? []).join(' '),
    ]
      .join(' ')
      .toLowerCase()
    return hay.includes(s)
  })
}
